import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

const options = {
    whoWeHelpClass: '.swiper.who-we-help-slider',
    imageClass: '.swiper.image-carousel-wrapper',
    testimonialClass: '.swiper.testimonial-slider-wrapper',
    twoColumnClass: '.swiper.two-column-slider-wrapper',
    logosClass: '.swiper.logos-slider',
    insightsClass: '.swiper.insights-slider',
    leadershipClass: '.swiper.leadership-slider',
    countryTeamClass: '.swiper.country-team-slider',
    countryInsightsClass: '.swiper.country-insights-slider',
}

const sliders = {
    init() {
        const whoWeHelpSlider = document.querySelectorAll(options.whoWeHelpClass);
        const imageSlider = document.querySelectorAll(options.imageClass);
        const testimonialSlider = document.querySelectorAll(options.testimonialClass);
        const twoColumnSlider = document.querySelectorAll(options.twoColumnClass);
        const logosSlider = document.querySelectorAll(options.logosClass);
        const insightsSlider = document.querySelectorAll(options.insightsClass);
        const leadershipSlider = document.querySelectorAll(options.leadershipClass);
        const countryTeamSlider = document.querySelectorAll(options.countryTeamClass);
        const countryInsightsSlider = document.querySelectorAll(options.countryInsightsClass);

        whoWeHelpSlider.forEach((item, index) => {
            const instanceClass = `swiper-${index}`;

            item.classList.add(instanceClass);
            swiperInit(`${options.whoWeHelpClass}.${instanceClass}`, {
                loop: true,
                pagination: pagination(),
                navigation: navigation(),
            });
        });

        imageSlider.forEach((item, index) => {
            const instanceClass = `swiper-${index}`;

            item.classList.add(instanceClass);
            swiperInit(`${options.imageClass}.${instanceClass}`, {
                loop: true,
                autoHeight: true,
                navigation: navigation(),
            });
        });

        testimonialSlider.forEach((item, index) => {
            const instanceClass = `swiper-${index}`;

            item.classList.add(instanceClass);
            swiperInit(`${options.testimonialClass}.${instanceClass}`, {
                loop: true,
                navigation: navigation(),
            });
        });

        twoColumnSlider.forEach((item, index) => {
            const instanceClass = `swiper-${index}`;

            item.classList.add(instanceClass);
            swiperInit(`${options.twoColumnClass}.${instanceClass}`, {
                loop: true,
                navigation: navigation(),
            });
        });

        logosSlider.forEach((item, index) => {
            const instanceClass = `swiper-${index}`;

            item.classList.add(instanceClass);
            swiperInit(`${options.logosClass}.${instanceClass}`, {
                slidesPerView: 'auto',
                pagination: pagination(),
            });
        });

        insightsSlider.forEach((item, index) => {
            const instanceClass = `swiper-${index}`;

            item.classList.add(instanceClass);

            const wrapper = item.closest('.latest-insights-new__slider-wrap, .slider-container') || item.parentElement;
            const nextEl = wrapper.querySelector('.next');
            const prevEl = wrapper.querySelector('.prev');

            new Swiper(`${options.insightsClass}.${instanceClass}`, {
                loop: true,
                slidesPerView: 'auto',
                spaceBetween: 30,
                navigation: { nextEl, prevEl },
                observer: true,
                observeParents: true,
                on: {
                    afterInit: (carousel) => { slideCount(carousel); }
                }
            });
        });

        leadershipSlider.forEach((item, index) => {
            const instanceClass = `swiper-${index}`;

            item.classList.add(instanceClass);

            const wrapper = item.closest('.leadership__slider-wrap, .slider-container') || item.parentElement;
            const nextEl = wrapper.querySelector('.next');
            const prevEl = wrapper.querySelector('.prev');

            new Swiper(`${options.leadershipClass}.${instanceClass}`, {
                loop: true,
                slidesPerView: 'auto',
                spaceBetween: 30,
                navigation: { nextEl, prevEl },
                breakpoints: {
                    993: {
                        slidesPerView: 4,
                    }
                },
                on: {
                    afterInit: (carousel) => { slideCount(carousel); }
                }
            });
        });

        countryTeamSlider.forEach((item, index) => {
            const instanceClass = `swiper-${index}`;

            item.classList.add(instanceClass);

            const wrapper = item.closest('.country-team__slider-wrap, .slider-container') || item.parentElement;
            const nextEl = wrapper.querySelector('.next');
            const prevEl = wrapper.querySelector('.prev');

            new Swiper(`${options.countryTeamClass}.${instanceClass}`, {
                loop: true,
                slidesPerView: 'auto',
                spaceBetween: 30,
                navigation: { nextEl, prevEl },
                breakpoints: {
                    993: {
                        slidesPerView: 4,
                    }
                },
                on: {
                    afterInit: (carousel) => { slideCount(carousel); }
                }
            });
        });

        countryInsightsSlider.forEach((item, index) => {
            const instanceClass = `swiper-${index}`;

            item.classList.add(instanceClass);

            const wrapper = item.closest('.country-latest-insights__slider-wrap, .slider-container') || item.parentElement;
            const nextEl = wrapper.querySelector('.next');
            const prevEl = wrapper.querySelector('.prev');

            new Swiper(`${options.countryInsightsClass}.${instanceClass}`, {
                loop: true,
                slidesPerView: 'auto',
                spaceBetween: 30,
                navigation: { nextEl, prevEl },
                breakpoints: {
                    993: {
                        slidesPerView: 3,
                    }
                },
                on: {
                    afterInit: (carousel) => { slideCount(carousel); }
                }
            });
        });

        clientsWordsNav();
    }
}

const clientsWordsNav = () => {
    document.querySelectorAll('.clients-words__cards').forEach((track) => {
        const wrap = track.closest('.clients-words');
        const navWrap = wrap && wrap.querySelector('.clients-words__nav-wrap');

        if (! navWrap) {
            return;
        }

        const prevBtn = navWrap.querySelector('.clients-words__nav-btn--prev');
        const nextBtn = navWrap.querySelector('.clients-words__nav-btn--next');

        const updateButtons = () => {
            const maxScrollLeft = track.scrollWidth - track.clientWidth;

            prevBtn.classList.toggle('is-disabled', track.scrollLeft <= 0);
            nextBtn.classList.toggle('is-disabled', track.scrollLeft >= maxScrollLeft - 1);
        };

        const scrollByCard = (direction) => {
            const card = track.querySelector('.clients-words__card');

            if (! card) {
                return;
            }

            const gap = parseFloat(getComputedStyle(track).columnGap) || 0;

            track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
        };

        prevBtn.addEventListener('click', () => scrollByCard(-1));
        nextBtn.addEventListener('click', () => scrollByCard(1));
        track.addEventListener('scroll', updateButtons);
        window.addEventListener('resize', updateButtons);

        updateButtons();
    });
}

export default sliders

const swiperInit = (slider, args) => {
    const eventArgs = {
        on: {
            afterInit: (carousel) => {
                slideCount(carousel);
            }
        }
    }

    if ('navigation' in args) {
        args['navigation']['nextEl'] = `${slider} ${args['navigation']['nextEl']}`;
        args['navigation']['prevEl'] = `${slider} ${args['navigation']['prevEl']}`;
    }

    if ('pagination' in args) {
        args['pagination']['el'] = `${slider} ${args['pagination']['el']}`;
    }

    new Swiper(slider, { ...args, ...eventArgs });
}

const navigation = () => {
    return {
        nextEl: '.next',
        prevEl: '.prev',
    }
}

const pagination = () => {
    return {
        el: '.pagination',
        clickable: true
    }
}

const slideCount = (carousel) => {
    if (carousel.slides.length <= 1) {
        carousel.el.classList.add('hide-controls');
    }
}